window.$ = require('jquery')
window._ = require('lodash')

const axios = require('axios')
const csrfToken = document.head.querySelector('meta[name="csrf-token"]').content

setupAxios()

$('form').submit(function () {
    $('input[type=hidden][name=_token]').remove()
    $('<input>').attr('type', 'hidden').attr('name', '_token').val(csrfToken).appendTo(this)
})

function setupAxios() {
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken
}
